import { SettingsManager } from "@viamap/viamap2-common";
import { Ejendomsbeliggenhed } from "./EBRTypes";

export class ebrCollector {

   static async EBRadresseForBFE(BFEnr: string) {
      return fetchEBR({ "BFEnr": BFEnr });
   }

}

function fetchEBR(query: any): Promise<Ejendomsbeliggenhed> {
   const serviceUrl = "https://services.datafordeler.dk/EBR/Ejendomsbeliggenhed/1/REST/Ejendomsbeliggenhed";
   const params = {
      username: SettingsManager.getSystemSetting("datafordelerUsername"),
      password: SettingsManager.getSystemSetting("datafordelerPassword"),
      ...query
   }
   return fetch(serviceUrl + `?${new URLSearchParams(params)}`, {
      method: 'GET',
      headers: {
         'Accept': 'application/json'
      }
   }).then(async res => {
      if (!res.ok) {
         await res.text().then(text => {
            console.error("Error response from EBR:", text);
         });
         throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json() as Promise<Ejendomsbeliggenhed>;
   });
}
